import { createFileRoute, redirect } from '@tanstack/react-router';
import { RecipeListScreen, type RecipeListSearch, type RecipeSegment } from '@/features/recipes/RecipeListScreen';

type Search = RecipeListSearch & { new?: boolean };

const truthy = (v: unknown) => v === true || v === 1 || v === '1' || v === 'true';

const SEGMENTS: RecipeSegment[] = ['dishes', 'prep', 'all'];

export const Route = createFileRoute('/_app/recipes/')({
  // ?type=dishes|prep|all picks the segment (D-10); /recipes alone is
  // Dishes, and /recipes?search=x with no type (the palette's "See all N
  // recipes") lands on All, since that count covers dishes and prep.
  // Legacy links keep working: ?ready=1 / ?ready_only=1 is the Dishes
  // segment, ?unused_only=1 the Unused filter, ?new=1 opens the builder.
  validateSearch: (s: Record<string, unknown>): Search => {
    const type = typeof s.type === 'string' && (SEGMENTS as string[]).includes(s.type) ? (s.type as RecipeSegment) : undefined;
    const ready = truthy(s.ready) || truthy(s.ready_only);
    return {
      search: typeof s.search === 'string' && s.search.trim() ? s.search : undefined,
      type: type ?? (ready ? 'dishes' : undefined),
      unused: truthy(s.unused) || truthy(s.unused_only) || undefined,
      new: truthy(s.new) || undefined,
    };
  },
  beforeLoad: ({ search }) => {
    if (search.new) throw redirect({ to: '/recipes/new' });
  },
  component: RecipesIndex,
});

function RecipesIndex() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RecipeListScreen
      search={{ search: search.search, type: search.type, unused: search.unused }}
      onSearchChange={(next) =>
        void navigate({
          search: { search: next.search || undefined, type: next.type || undefined, unused: next.unused || undefined },
          replace: true,
        })
      }
    />
  );
}
